const offsettingCssClass = (breakpoint) => {
  // Use offset classes to offset content by a given column span.
  // These classes increase the left margin of a column by X columns.

  const obj = breakpoint.value.split("-", 2);
  const offset = obj[0];
  const span = obj[1];

  return `bx--offset-${breakpoint.name}-${offset} bx--col-${breakpoint.name}-${span} `;
};

const columnCssClass = (breakpoint) => {
  if (breakpoint.value === "auto") {
    return `bx--col`;
  } else if (isNaN(breakpoint.value)) {
    return offsettingCssClass(breakpoint);
  }

  return `bx--col-${breakpoint.name}-${breakpoint.value}`;
};

export default {
  props: {
    max: { type: String, default: undefined },
    xlg: { type: String, default: undefined },
    lg: { type: String, default: undefined },
    md: { type: String, default: undefined },
    sm: { type: String, default: undefined },
  },
  computed: {
    cssClass() {
      let cssClasses = [];
      let columnSettings = [
        {
          name: "max",
          value: this.max,
        },
        {
          name: "xlg",
          value: this.xlg,
        },
        {
          name: "lg",
          value: this.lg,
        },
        {
          name: "md",
          value: this.md,
        },
        {
          name: "sm",
          value: this.sm,
        },
      ];

      for (var i = 0, len = columnSettings.length; i < len; i++) {
        if (columnSettings[i].value) {
          let cssClass = columnCssClass(columnSettings[i]);
          if (cssClass) {
            cssClasses.push(cssClass);
          }
        }
      }

      return cssClasses.length > 0 ? cssClasses : "bx--col";
    },
  },
};
